import React from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import styles from './styles.module.scss'
import { IoMdLogOut, IoMdNotificationsOutline } from 'react-icons/io'
import { FaServer } from 'react-icons/fa'
import { useDispatch } from 'react-redux';
import { signOut } from '../../actions/auth';
import cn from 'classnames'


const MENU_ITEMS = [
  { name: 'Главная', path: '/dashboard' },
  { name: 'Сервера ОО', path: '/servers' },
  { name: 'Сервера ГУК', path: '/guk_servers' },
]

const Layout = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const signOuthandler = () => dispatch(signOut())

  const handleMenuClick = (path) => {
    navigate(path)
  }

  return (
    <div className={styles.wrapper}>
      <header>
        <div className={styles.headerTop}>
          <div className={styles.headerLeft}>
            {/* <div className={styles.logoIcon}>
              <FaServer size={24} />
            </div> */}
            <img src='/LMSLogo.png' alt='o_O' style={{ width: 100 }} />
            <div className={styles.headerTitle}>
              <h3>Мониторинг серверов LMS Школа</h3>
              <p className={styles.subtitle}>Система контроля серверов</p>
            </div>
            <img src='/favicon.ico' alt='o_O' style={{ width: 50 }} />
          </div>
          <nav className={styles.nav}>
            <ul className={styles.menu}>
              {MENU_ITEMS.map(({ name, path }) => {
                const isActive = pathname === path || pathname.startsWith(path + '/')
                return (
                  <li
                    key={path}
                    onClick={() => handleMenuClick(path)}
                    className={cn(styles.menuItem, { [styles.active]: isActive })}
                  >
                    {name}
                  </li>
                )
              })}
            </ul>
          </nav>
          <div className={styles.headerRight}>
            {/* <div className={styles.onlineIndicator}>
              <span className={styles.onlineDot}></span>
              <span>Онлайн</span>
            </div>
            <IoMdNotificationsOutline size={24} className={styles.notificationIcon} /> */}
            <IoMdLogOut size={24} onClick={signOuthandler} className={styles.logoutIcon} />
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  )
}

export default Layout